<template>
  <div
    class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-0 mt-4 search-complaints"
  >
    <a-table
      :columns="columns"
      rowKey="id"
      :data-source="dataSource"
      :pagination="false"
      :scroll="{ x: '1220px' }"
      :locale="{ emptyText: emptyTemplate }"
    >
      <div
        slot="codigo_queja"
        class="title-size font-bold text-gray-500 text-center"
      >
        Código de queja
      </div>
      <div
        slot="macro_motivo_cod"
        class="title-size font-bold text-gray-500 text-center"
      >
        Motivo de queja
      </div>
      <div
        slot="tipo_id_CF"
        class="title-size font-bold text-gray-500 text-center"
      >
        Tipo de identificación
      </div>
      <div
        slot="numero_id_CF"
        class="title-size font-bold text-gray-500 text-center"
      >
        No. de identificación
      </div>

      <div slot="fecha_creacion" class="title-size font-bold text-gray-500">
        Fecha de creación
      </div>

      <div
        slot="estado_cod"
        class="title-size font-bold text-gray-500 text-center"
      >
        Estado
      </div>

      <!-- Custom rendering for estado_cod column -->
      <template slot="estado_cod" slot-scope="text, record">
        <ComplaintAgilizaStatusLabel :status="record.estado_cod" />
      </template>

      <div slot="actions" class="title-size font-bold text-gray-500">
        Acciones
      </div>

      <div
        slot="actions"
        slot-scope="text, record"
        class="flex flex-row justify-center items-center space-x-2"
      >
        <!-- Botón Ver - Sin un estado especifico -->
        <template
          v-if="
            record.estado_cod !== STATE_CF_PROPOSAL_SUPERVISED_ENTITY &&
            record.estado_cod !== STATE_EV_PENDING_ACTION
          "
        >
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="redirectComplaintAgiliza(record.codigo_queja)"
          >
            <a-icon
              type="eye"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>

        <!-- Botón Ver - Contrapropuesta entidad vigilada -->
        <template
          v-if="record.estado_cod === STATE_CF_PROPOSAL_SUPERVISED_ENTITY"
        >
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="redirectProposalAgiliza(record.codigo_queja)"
          >
            <a-icon
              type="eye"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>
        <!-- Botón Editar - Gestion pendiente (EV debe presentar contraoferta) -->
        <template v-if="record.estado_cod === STATE_EV_PENDING_ACTION">
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="redirectProposalAgiliza(record.codigo_queja)"
          >
            <a-icon
              type="edit"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>
      </div>
    </a-table>
  </div>
</template>

<script>
import ComplaintAgilizaStatusLabel from "@/feature/shared/presentation/partials/ComplaintAgilizaStatusLabel.vue";
import ComplaintEmisorStatusLabel from "../partials/ComplaintEmisorStatusLabel.vue";
import {
  STATE_CF_PROPOSAL_SUPERVISED_ENTITY,
  STATE_EV_PENDING_ACTION,
} from "@/core/utils/constants";

const columns = [
  {
    slots: { title: "codigo_queja" },
    dataIndex: "codigo_queja",
    key: "codigo_queja",
    width: 100,
  },
  {
    slots: { title: "macro_motivo_cod" },
    dataIndex: "macro_motivo_cod",
    key: "macro_motivo_cod",
    width: 100,
  },
  {
    slots: { title: "tipo_id_CF" },
    dataIndex: "tipo_id_CF",
    key: "tipo_id_CF",
    width: 110,
  },
  {
    slots: { title: "numero_id_CF" },
    dataIndex: "numero_id_CF",
    key: "numero_id_CF",
    width: 110,
  },
  {
    slots: { title: "fecha_creacion" },
    dataIndex: "fecha_creacion",
    key: "fecha_creacion",
    width: 100,
  },
  {
    slots: { title: "estado_cod" },
    dataIndex: "estado_cod",
    key: "estado_cod",
    scopedSlots: { customRender: "estado_cod" }, // Enable custom rendering
    width: 130,
  },

  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    width: 75,
  },
];

export default {
  components: {
    ComplaintAgilizaStatusLabel,
    ComplaintEmisorStatusLabel,
  },
  props: ["dataSource"],
  data() {
    return {
      columns,
      emptyTemplate: (
        <div style="text-align: center; padding: 20px;">
          <a-icon type="inbox" style="font-size: 48px; " />
          <p
            style="margin-top: 8px; font-size: 18px;"
            class="text-gray-500 font-bold"
          >
            No se encontraron resultados
          </p>
        </div>
      ),
      STATE_CF_PROPOSAL_SUPERVISED_ENTITY,
      STATE_EV_PENDING_ACTION,
    };
  },
  methods: {
    redirectComplaintAgiliza(codigo_queja) {
      this.$router.push(
        `/dashboard/complaints-agiliza/details?complaint_id=${codigo_queja}&type=agiliza`,
      );
    },
    redirectProposalAgiliza(codigo_queja) {
      this.$router.push(
        `/dashboard/complaints-agiliza/details?complaint_id=${codigo_queja}&type=agiliza&action=contrapropuesta`,
      );
    },
  },
};
</script>
